<!--
  sessionExpired.vue ( etc, mblElcSgn09 )
  - 세션 만료 및 예외 페이지
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <!--Header [s]-->
    <Header :rtrnAnimInsYn="state.rtrnAnimInsYn" />
    <!--Header [e]-->
    <!-- Container [s] -->
    <div class="container type_complete">
      <!-- 완료페이지만 : type_complete 클래스 적용 -->
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <div class="finish_wrap">
            <p>비정상적인 방법으로 접속하였습니다.</p>
          </div>
          <div class="btn_area">
            <button type="button" class="btn_main" @click="goHome">
              <span>홈으로 이동</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer :rtrnAnimInsYn="state.rtrnAnimInsYn" />
  </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";

export default {
  name: "sessionExpired",
  components: {
    Header,
    Footer,
  },
  setup() {
    const router = useRouter();

    var state = reactive({
      rtrnAnimInsYn: false,
      mode: process.env.NODE_ENV,
    });

    const goHome = () => {
      let url = "";
      if (state.mode == "development") {
        url = "https://mdev.meritzfire.com:16541/main.do";
      } else {
        url = "https://m.meritzfire.com/main.do";
      }
      location.href = url;
    };

    return {
      state,
      goHome,
    };
  },
};
</script>
